var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reset-password-component',{attrs:{"user-email":_vm.userEmail,"is-loading":_vm.isLoading},on:{"updatePassword":_vm.updatePassword}})}
var staticRenderFns = []

export { render, staticRenderFns }